<template>
  <v-card class="pa-2 px-4">
    <div class="pb-2">Featured User</div>
    <v-divider></v-divider>
    <div v-if="loading" class="my-3 text-center">
      <v-progress-circular indeterminate />
    </div>
    <div v-else>
      <ProfileUserCard
        v-for="item of items"
        :key="item.id"
        :item="item"
        v-bind:isConnectBtn="false"
      />
    </div>
  </v-card>
</template>

<script>
import ProfileUserCard from "../ProfileUserCard.vue";
export default {
  name: "featuredUser",
  components: { ProfileUserCard },
  props:["loading","items"],
  mounted(){
    
  }
};
</script>

<style>
</style>